/**
 * @generated SignedSource<<b9c6217d782fd18574b8f6f54aec257c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SnsAssociation$data = {
  readonly id: string;
  readonly tiktokOauthEnabled: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"SnsAssociationTiktok" | "SnsAssociationTiktokOAuth" | "SnsAssociationYoutube">;
  readonly " $fragmentType": "SnsAssociation";
};
export type SnsAssociation$key = {
  readonly " $data"?: SnsAssociation$data;
  readonly " $fragmentSpreads": FragmentRefs<"SnsAssociation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SnsAssociation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tiktokOauthEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SnsAssociationTiktok"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SnsAssociationTiktokOAuth"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SnsAssociationYoutube"
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "1a970a07a8bb9a151327141f9b6bb365";

export default node;
